module.exports = __webpack_public_path__ + "img/maximize.4898f3a9.svg";